import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material'
import { ArrowDropDownIcon } from '@mui/x-date-pickers/icons'
import { FC, ReactNode } from 'react'
import QuestionCircleIcon from '../../../../assets/icons/QuestionCircle.svg?react'

type Props = {
    title: string
    tooltip: string
    value: string
    expanded: string
    onChange: (value: string) => void
    details: ReactNode
    divider?: boolean
}

export const SettingsAccordion: FC<Props> = ({
    title,
    tooltip,
    expanded,
    value,
    onChange,
    details,
    divider,
}) => {
    const isExpanded = expanded === value

    const handleChange = () => {
        onChange(isExpanded ? '' : value)
    }

    return (
        <Stack>
            <Accordion expanded={isExpanded} onChange={handleChange}>
                <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    sx={{
                        '& .MuiAccordionSummary-content': {
                            alignItems: 'center',
                        },
                    }}>
                    <Typography component="span">{title}</Typography>
                    <Tooltip title={tooltip}>
                        <IconButton>
                            <QuestionCircleIcon />
                        </IconButton>
                    </Tooltip>
                </AccordionSummary>
                <AccordionDetails>{details}</AccordionDetails>
            </Accordion>
            {divider && <Divider />}
        </Stack>
    )
}
